module.exports = __webpack_public_path__ + "img/man--mobile.4ffa2064.jpg";